import { FIELD_TYPES } from "constants/template-field-type";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import FullParagraphFieldConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import buttonConfig from "segments/desktop/core-components/button/signup-button/fields-config.js";
import { PRODUCT_OPTIONS } from "constants/products";
import paragraphAdvancedConfig from "segments/desktop/core-components/paragraph/advanced-fields-config";

const { signupWithsolutionAppReferenceId, signupClusterId, ...restSignupButtonConfig } = buttonConfig;
const { textSize } = paragraphAdvancedConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Monday Products",
  fields: {
    fullParagraph: {
      type: FIELD_TYPES.NESTED,
      label: "Full paragraph",
      fields: FullParagraphFieldConfig
    },
    subTitle: {
      type: FIELD_TYPES.NESTED,
      label: "Sub title",
      fields: TitleConfig
    },
    buttonConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Signup button",
      fields: restSignupButtonConfig
    },
    distanceOfBottomPartFromTop: {
      type: FIELD_TYPES.TEXT,
      label: "Distance of bottom part from top when hovered"
    },
    cardWidth: { type: FIELD_TYPES.TEXT, label: "Card Width" },
    logoWidth: { type: FIELD_TYPES.TEXT, label: "Logo Width" },
    cardBackSidePaddingTop: { type: FIELD_TYPES.TEXT, label: "Card Back Side Padding Top" },
    departmentsHeight: { type: FIELD_TYPES.TEXT, label: "Departments Height" },
    departmentsTitle: { type: FIELD_TYPES.TEXT, label: "Departments title" },
    products: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Products",
      maxLimit: 3,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          productType: {
            type: FIELD_TYPES.COMBO,
            label: "Product type",
            options: PRODUCT_OPTIONS
          },
          text: { type: FIELD_TYPES.TEXT, label: "Card Text", translatable: true, textArea: true },
          textSize,
          marginAboveCardText: { type: FIELD_TYPES.TEXT, label: "Margin Above Card Text" },
          marginUnderCardText: { type: FIELD_TYPES.TEXT, label: "Margin Under Card Text" },
          logoImage: { type: FIELD_TYPES.GALLERY, label: "Product Logo Image" },
          productImage: { type: FIELD_TYPES.GALLERY, label: "Product Image" },
          backgroundColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Color" },
          cardMainColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Card Main Color" },
          cardButtonColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Card Main CTA Button Color" },
          useCasesTagesTextColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Use Cases Tags Text Color" },
          useCasesTagsBackgroundColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Use Cases Tags Background Color" },
          departments: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Departments",
            maxLimit: 10,
            nestedConfig: {
              type: FIELD_TYPES.NESTED,
              fields: {
                text: { type: FIELD_TYPES.TEXT, label: "Text", translatable: true }
              }
            }
          },
          useCases: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use Cases",
            maxLimit: 10,
            nestedConfig: {
              type: FIELD_TYPES.NESTED,
              fields: {
                text: { type: FIELD_TYPES.TEXT, label: "Text", translatable: true }
              }
            }
          }
        }
      }
    }
  }
};
